import React from "react";
import {Link, NavLink} from 'react-router-dom'

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { DataGrid } from '@mui/x-data-grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';
import {Loading} from '../../custom/LoadingComponent';
import {getAuthzIscirName, getAuthzsIscirStatusName, getReminderName, getAuthzTypeName} from '../../util/TypeConvertor';
import {getAuthzInternalName} from '../../util/TypeConvertor';
import {EntityType} from '../../constants/Consts';
import * as CustomStyles from '../../styles/CustomStyles';
import * as Formatter from '../../util/Formatter';


function EmployeeAuthorizations(props) {
    const [anchorNewAuthz, setAnchorNewAuthz] = React.useState(null);

    const handleOpenNewAuthzMenu = (event) => {
        setAnchorNewAuthz(event.currentTarget);
    };
    const handleCloseNewAuthzMenu = () => {
        setAnchorNewAuthz(null);
    };

    const authzsColumns = [
        {
            field: 'authzISCIR',
            headerName: 'Autorizatie',
            width: 350,
            valueGetter: (params) => {
                if(params.row.type === EntityType.AuthzIscir)
                    return(
                        getAuthzIscirName(params.row.autorizatie.authISCIR)
                    );
                else
                    return(
                        getAuthzInternalName(params.row.autorizatie.authInternal)
                    );
        },
            renderCell: (params) => {
                if(params.row.type === EntityType.AuthzIscir)
                    return(
                        <Link to={`/employees/authzs/iscir/${params.row.id}`}>
                            {getAuthzIscirName(params.row.autorizatie.authISCIR)}
                        </Link>
                    );
                else
                    return(
                        <Link to={`/employees/authzs/internal/${params.row.id}`}>
                            {getAuthzInternalName(params.row.autorizatie.authInternal)}
                        </Link>
                    );
        },
            //sortComparator: (a,b) => a.localeCompare(b)
        },
        {
            field: 'authzsType',
            headerName: 'Tip',
            width: 75,
            valueGetter: (params) => params.row.type,
            renderCell: (params) => {
                return(getAuthzTypeName(params.row.type));
            }
        },
        {
            field: 'authzsStatus',
            headerName: 'Status',
            width: 100,
            valueGetter: (params) => params.row.autorizatie.status,
            renderCell: (params) => {
                return(getAuthzsIscirStatusName(params.row.autorizatie.status));
            }
        },
        {
            field: 'reminderType',
            headerName: 'Reminder',
            width: 200,
            valueGetter: (params) => params.row.reminder?.type ? params.row.reminder.type : '',
            renderCell: (params) => {
                return( params.row.reminder?.type ? getReminderName(params.row.reminder.type) : '');
            }
        },
        {
            field: 'expiryDate',
            headerName: 'Expira',
            width: 115,
            valueGetter: (params) => params.row.reminder?.dataExpirare ? params.row.reminder.dataExpirare : '',
            renderCell: (params) => {
                return( params.row.reminder?.dataExpirare ? Formatter.formatDatetoRO(params.row.reminder.dataExpirare) : '');
            }
        },
        {
            field: 'updateDate',
            headerName: 'Data Modificare',
            width: 115,
            valueGetter: (params) => params.row.updateDate,
            renderCell: (params) => {
                return(Formatter.formatDatetoRO(params.row.updateDate));
            }            
        },
        {
            field: 'updateBy',
            headerName: 'Modificat De',
            width: 150,
            valueGetter: (params) => params.row.updateBy?.updateByFullName,
        },
    ];

    return(
        <Box sx={CustomStyles.boxStyles} >
            <div style={{display:"flex"}}>
                <Box sx={{ width:'100%', marginTop: 2}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                    <Button onClick={handleOpenNewAuthzMenu} variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga </Button>

                    <Menu
                        sx={{ mt: '45px' }}
                        id="menu-appbar"
                        anchorEl={anchorNewAuthz}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorNewAuthz)}
                        onClose={handleCloseNewAuthzMenu}
                    >
                        <MenuItem key="profile-key" onClick={handleCloseNewAuthzMenu}>
                            <NavLink className="nav-link" to={`/employees/newauthz-iscir?employeeId=${props.employee.id}`}>Autorizatie ISCIR</NavLink>
                        </MenuItem>
                        <MenuItem key="logout-key" onClick={handleCloseNewAuthzMenu}>
                            <NavLink className="nav-link" to={`/employees/newauthz-internal?employeeId=${props.employee.id}`}>Autorizatie Interna</NavLink>
                        </MenuItem>
                    </Menu>
                </Box>
            </div>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={12}>
                    <Box sx={{ height: 350, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        {props.authorizationsDataStatus === ReduxDataStatus.LOADING ? 
                            <Loading />
                            :
                            <DataGrid
                                rows={props.authorizations}
                                columns={authzsColumns}
                                pageSize={10}
                                rowsPerPageOptions={[10]}
                                checkboxSelection={false}
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                            />
                        }
                    </Box>
                </Grid>
            </Grid>

        </Box>
    );
}

export default EmployeeAuthorizations;